import React, { useEffect, useState } from "react";
import Tab from "@material-ui/core/Tab";
import ViewSelector from "../common/ViewSelector";
import { useStyles } from "../CommunitySolar/styles";
import { Accordion, AccordionDetails, AccordionSummary, Checkbox, FormControlLabel, FormGroup, Grid, Typography } from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";
import ReactTable from "react-table";

const RateTableTabs = ({ rate_list, columns, rate_types }) => {
  const classes = useStyles();
  const [activeView, setActiveView] = useState(0);
  const [activeRateView, setActiveRateView] = useState({})
  const [checkedOptions, setCheckedOptions] = useState({})
  const [selectedStatuses, setSelectedStatuses] = useState({})
  const [expandedAccordion, setExpandedAccordion] = useState({})

  const viewNames = ["All", ...new Set(rate_list?.map(row => row.state_code ?? ""))].filter((row) => row !== "").sort((a, b) => a.localeCompare(b));
  const allTDSPNames = [...new Set(rate_list?.map(row => row.tdsp_name ?? ""))].filter((row) => row !== "").sort((a, b) => a.localeCompare(b));
  const stateTDSPNames = [...new Set(rate_list.filter(row => row.state_code === viewNames[activeView]).map(row => row.tdsp_name ?? ""))].filter((row) => row !== "").sort((a, b) => a.localeCompare(b));

  const dropDownOptions = activeView === 0 ? allTDSPNames : stateTDSPNames
  const viewStatusNames = ["All", "actual", "proposed", "forecasted"]

  const handleRateViewChange = (tdsp) => (viewIndex) => {
    setActiveRateView((prev) => ({
      ...prev,
      [tdsp]: viewIndex
    }))
  }

  const handleChecked = (event, id) => {
    setCheckedOptions((prev) => {

      if (event.target.name === "All") {
        return {
          ...prev,
          [id]: { "All": true, "actual": false, "proposed": false, "forecasted": false }
        }
      }

      const checkedOptions = {
        ...(prev[id] || {}),
        "All": false,
        [event.target.name]: event.target.checked,
      }

      if (!checkedOptions['actual'] && !checkedOptions['proposed'] && !checkedOptions['forecasted']) {
        return {
          ...prev,
          [id]: { "All": true, "actual": false, "proposed": false, "forecasted": false }
        }
      }

      return { ...prev, [id]: checkedOptions }

    })

    setSelectedStatuses((prev) => {
      if (event.target.name === "All") {
        return {
          ...prev,
          [id]: []
        }
      }

      const oldList = prev[id] || []

      return { ...prev, [id]: event.target.checked ? [...oldList, event.target.name] : oldList.filter((row) => row !== event.target.name) }

    })
  }

  const handleAccordionExpand = (id) => (event, isExpanded) => {
    setExpandedAccordion((prev) => ({
      ...prev,
      [activeView]: {
        ...prev[activeView] || {},
        [id]: isExpanded
      }
    }))
  }

  const getData = (tdsp_name, rate_type, id) => {

    const filteredData = rate_list.filter((row) => row.tdsp_name === tdsp_name)
      .filter((row) => row.rate_type === rate_type)
      .filter((row) => selectedStatuses[id]?.length === 0 || selectedStatuses[id]?.includes(row.status) || !selectedStatuses[id])
      ?.sort((a, b) => new Date(b.start_date) - new Date(a.start_date))

    if (filteredData.length === 0) {
      return [{ data: "empty", tdsp_name: tdsp_name, rate_type_name: rate_type }]
    }

    return filteredData
  }

  useEffect(() => {
    setExpandedAccordion((prev) => ({
      ...prev,
      [activeView]: {}
    }))
  }, [activeView])

  return (
    <div className={classes.viewContainer}>
      <ViewSelector
        viewNames={viewNames}
        activeView={activeView}
        isRate={true}
        setActiveView={setActiveView}
      >
        {viewNames.map((option, index) => (
          <Tab
            key={index}
            className={activeView === index ? `view activeView` : `view`}
            label={option}
            style={{ minWidth: '5em' }}
          />
        ))}
      </ViewSelector>
      <div style={{ marginTop: "20px" }}>
        {
          dropDownOptions.map((row, id) => {
            const state_code = rate_list?.filter(row => row.tdsp_name === dropDownOptions[id])[0]?.state_code

            const filteredRateTypes = rate_types?.filter(item => {
              if (!item.rate_type_eligibility) return true;

              return Array.isArray(item.rate_type_eligibility) && item.rate_type_eligibility.includes(state_code)
            }).map(row => row.type) || []

            return (
              <Accordion key={`${activeView}-${id}`} style={{ marginBottom: "10px" }} expanded={expandedAccordion[activeView]?.[id]} onChange={() => {
                handleAccordionExpand(id)
                setActiveRateView(0)
              }}>
                <AccordionSummary expandIcon={<ExpandMore />}>
                  <Typography>{row || "N/A"}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container>
                    <Grid style={{ gap: '20px', display: 'flex', alignItems: 'center' }} item sm={12}>
                      <ViewSelector
                        viewNames={filteredRateTypes}
                        activeView={activeRateView[id] || 0}
                        isRate={false}
                        setActiveView={handleRateViewChange(id)}
                      >
                        {filteredRateTypes?.map((option, index) => (
                          <Tab
                            key={index}
                            className={(activeRateView[id] || 0) === index ? `view activeView` : `view`}
                            label={option}
                          />
                        ))}
                      </ViewSelector>
                    </Grid>
                    <Grid style={{ gap: '20px', display: 'flex', alignItems: 'center' }} item sm={12}>
                      <FormGroup row>
                        {viewStatusNames.map((option) => (
                          <FormControlLabel
                            key={option}
                            control={
                              <Checkbox
                                checked={checkedOptions[id] ? checkedOptions[id][option] || false : option === "All"}
                                onChange={(e) => handleChecked(e, id)}
                                name={option}
                              />
                            }
                            label={option}
                          />
                        ))}
                      </FormGroup>
                    </Grid>
                    <Grid style={{ gap: '20px', display: 'flex', alignItems: 'center' }} item sm={12}>
                      <ReactTable
                        data={getData(dropDownOptions[id], filteredRateTypes[activeRateView[id] || 0], id)}
                        columns={columns(filteredRateTypes[activeRateView[id] || 0])}
                        style={{ textAlign: 'center' }}
                        className="-striped -highlight"
                        defaultPageSize={10}
                        defaultSortDesc
                        filterable
                      />
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            )
          })
        }
      </div>
    </div>
  );
};

export default RateTableTabs;
